import React, { useState } from 'react'
import Modal from '../Modal/Modal'
import { DirectDepositIcon, LeftArrowIcon, TransferWireIcon } from '../../../../assets/icons/svgicons';
import StripeIcon from '../../../../assets/icons/stripeIcon.svg'
import styles from "./AddPaymentMethod.module.scss"
import AddStripeConfirmation from '../AddStripeConfirmation/AddStripeConfirmation'
import DirectDeposit from '../DirectDeposit/DirectDeposit'
import WireTransfer from '../WireTransfer/WireTransfer'

const AddPaymentMethod = ({ show, handleClose, handleShow }) => {
    const [showAddStripe, setShowAddStripe] = useState(false);
    const [showDirectDeposit, setShowDirectDeposit] = useState(false);
    const [showWireTransfer, setShowWireTransfer] = useState(false);
    return (
        <>
            <Modal
                show={show}
                handleClose={handleClose}
                title={
                    <span onClick={handleClose}>
                        <LeftArrowIcon />Back
                    </span>
                }
                hideCloseBtn
                className={styles.add_method}
            >
                <ul>
                    <li>
                        <button
                            onClick={() => { setShowAddStripe(true); handleClose() }}
                        >
                            <span className={styles.method_icon}>
                                <img src={StripeIcon} alt='strip-Icon' />
                            </span>
                            <div>
                                <h6>Stripe</h6>
                                <p>Invest up to $1000</p>
                                <h6>Use this for basic payments</h6>
                            </div>
                        </button>
                    </li>
                    {/* <li>
                        <button onClick={() => { setShowDirectDeposit(true); handleClose() }}>
                            <span className={styles.method_icon}>
                                <DirectDepositIcon />
                            </span>
                            <div>
                                <h4>Direct Deposit</h4>
                                <p>Invest large amount</p>
                                <h5>Use this for basic payments</h5>
                            </div>
                        </button>
                    </li> */}
                    <li>
                        <button onClick={() => { handleClose(); setShowWireTransfer(true) }}>
                            <span className={styles.method_icon}>
                                <TransferWireIcon />
                            </span>
                            <div>
                                <h6>Wire Transfer</h6>
                                <p>Invest up to $100,000</p>
                                <h6>Use this for basic payments</h6>
                                <p>No fees charged (your bank may charge a wire fee)</p>
                            </div>
                        </button>
                    </li>
                </ul>
            </Modal>
            <AddStripeConfirmation
                show={showAddStripe}
                handleClose={() => { setShowAddStripe(false) }}
                handleBack={() => { handleShow(); setShowAddStripe(false) }}
            />
            <DirectDeposit
                show={showDirectDeposit}
                handleClose={() => setShowDirectDeposit(false)}
            />
            <WireTransfer
                show={showWireTransfer}
                handleClose={() => setShowWireTransfer(false)}
            />
        </>
    )
}

export default AddPaymentMethod
